import styled from 'styled-components';
import { TextStyles } from '@/constants';
import { Typography } from '@/components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: ${({ theme }) => `${theme.spacing[32]} 0`};
`;

export const MainText = styled(Typography).attrs({
  variant: TextStyles['Heading 3'],
})`
  ${({ theme }) => `
    color: ${theme.colors.inactiveBlack};
    margin-top: ${theme.spacing[32]};
`}
`;

export const SubText = styled(Typography).attrs({
  variant: TextStyles['Body Text Large'],
})`
  ${({ theme }) => `
    color: ${theme.colors.highEmphasisBlack};
    margin-top: ${theme.spacing[8]};
  `}
`;
